import Api from './api.service'

import Configuration from '@/configuration';
const baseURL = Configuration.value('apiFrontend')
const baseAdminURL = Configuration.value('apiBackend')

export default {
  get() {
    return Api().get(`${baseURL}/banner`)
  },
  remove(id) {
    return Api().delete(`${baseAdminURL}/banner/${id}`)
  }
}
